import React from "react";
import materiaStyles from '../../styles/MateriasStyles/PantallaDeTareas.v2.module.css';
import programsStyles from '../../styles/PantallaDeProgramasAcademicos.v2.module.css';
import Pagination from '../../components/Pagination.tsx';
import StatusBadge from "./StatusBadge";
import ActionButtons from "./ActionButtons";
import TableHeader from "./TableHeader";

const TeachersTable = ({ teachers = [], loading = false }) => {
  // PAGINATION LOGIC (igual que MateriasTable)
  const [page, setPage] = React.useState(1);
  const pageSize = 8;
  const totalPages = Math.max(1, Math.ceil(teachers.length / pageSize));
  const paginated = teachers.slice((page - 1) * pageSize, page * pageSize);

  // Mantener la página actual al editar/guardar.
  // Solo reseteamos si la página actual queda fuera de rango
  // (por ejemplo, después de eliminar y reducir el total de páginas).
  React.useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);
  // Eliminar goToPage, usaremos Pagination global

  if (loading) {
    return (
      <section className={materiaStyles.tableContainer}>
        <TableHeader />
        <div style={{ padding: '20px', textAlign: 'center' }}>Cargando asesores...</div>
      </section>
    );
  }

  if (!teachers.length) {
    return (
      <section className={materiaStyles.tableContainer}>
        <TableHeader />
        <div style={{ padding: '20px', textAlign: 'center' }}>No hay asesores registrados.</div>
      </section>
    );
  }

  // Columnas responsivas optimizadas (eliminadas Campus y Lugar de Nacimiento)
  const gridCols = [
    'minmax(160px, 1.9fr)', // Nombre
    'minmax(100px, 1.1fr)', // C. Emp.
    'minmax(180px, 2fr)',   // Email Institucional
    'minmax(130px, 1.3fr)', // Academia
    'minmax(110px, 1.1fr)', // Nacionalidad
    'minmax(110px, 1.1fr)', // Estado
    'minmax(110px, 1.1fr)'  // Acciones
  ].join(' ');

  return (
    <section className={materiaStyles.tableContainer}>
      <TableHeader />
      <div
        className={materiaStyles.tableHeaderRow}
        style={{ gridTemplateColumns: gridCols }}
      >
        <div className={materiaStyles.columnHeader}>
          <span>Nombre</span>
          <img src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/ebc744283453a489241d0bc1de701680c59165c8?placeholderIfAbsent=true" alt="Ordenar" className={materiaStyles.sortIcon} />
        </div>
        <div className={materiaStyles.columnHeader}>
          <span>C. Emp.</span>
          <img src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/ebc744283453a489241d0bc1de701680c59165c8?placeholderIfAbsent=true" alt="Ordenar" className={materiaStyles.sortIcon} />
        </div>
        <span className={materiaStyles.columnHeader}>Email Institucional</span>
        <div className={materiaStyles.columnHeader}>
          <span>Academia</span>
          <img src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/ebc744283453a489241d0bc1de701680c59165c8?placeholderIfAbsent=true" alt="Ordenar" className={materiaStyles.sortIcon} />
        </div>
        <span className={materiaStyles.columnHeader}>Nacionalidad</span>
        <div className={materiaStyles.columnHeader}>
          <span>Estado</span>
          <img src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/15db0f3a70508180315f320d367e494d2cad9056?placeholderIfAbsent=true" alt="Ordenar" className={materiaStyles.sortIcon} />
        </div>
        <span className={materiaStyles.columnHeader}>Acciones</span>
      </div>

      <div className={materiaStyles.tableBody}>
        {paginated.map((t, idx) => (
          <div
            key={t.id_docente || t.id_asesor || idx}
            className={materiaStyles.tableRow}
            style={{ gridTemplateColumns: gridCols }}
          >
            <div className={materiaStyles.cellData}>{t.name || t.nombre_completo || '-'}</div>
            <div className={materiaStyles.cellData}>{t.empCode || '-'}</div>
            <div className={materiaStyles.cellData}>{t.email || '-'}</div>
            <div className={materiaStyles.cellData}>{t.academy || t.academia_nombre || '-'}</div>
            <div className={materiaStyles.cellData}>{t.nationality || '-'}</div>
            <div className={materiaStyles.statusCell}>
              <StatusBadge status={t.status}>
                {t.status === 'active' ? 'ACTIVO' : t.status === 'baja' ? 'BAJA' : 'INACTIVO'}
              </StatusBadge>
            </div>
            <div className={materiaStyles.actionButtons}>
              <ActionButtons teacherId={t.id_docente || t.id_asesor} />
            </div>
          </div>
        ))}
      </div>

      {/* Paginación global */}
      {teachers.length > pageSize && (
        <Pagination
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
          className={programsStyles.paginationWrapper}
        />
      )}
    </section>
  );
}

export default TeachersTable;
